var exports = {
  "U": "xaf9ae18d--c2e50f--arrow",
};

module.exports = exports;
